import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  每週幾次: {
    "7次(含以上)": 0,
    "6次": 1,
    "5次": 2,
    "4次": 3,
    "3次": 4,
    "2次": 5,
    "1次": 6,
    一週不到一次: 7,
    "不知道、拒答": 8,
  },
};

export const ExerciseHabitsTimesToBMI = {
  label: "運動習慣每週幾次 vs BMI",
  key: "ExerciseHabitsTimesToBMI",
  path: "BMI/ExerciseHabitsTimesToBMI",
  api: "TCS_V_BMISportQ73V",
  render: (options) => <Diagram.BMI.ExerciseHabitsTimesToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupOrders,
  groupColumns: [
    {
      key: "每週幾次",
      field: "每週幾次",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
